<div class="d-flex flex-row flex-wrap gap-8px" *ngIf="desktop$ | async">
  <ng-container *ngFor="let badge of badges">
    <ng-container *ngIf="!badge?.hidden">
      <ng-container *ngIf="badge?.component else notComponent">
        <app-insight-badge-container [data]="data" [badgeComponent]="badge?.component"
                                     (anchorClick)="onAnchorClick($event)"></app-insight-badge-container>
      </ng-container>
      <ng-template #notComponent>
        <app-insight-badge [badge]="badge" (anchorClick)="onAnchorClick($event)"></app-insight-badge>
      </ng-template>
    </ng-container>
  </ng-container>
</div>

<div class="d-block" style="width: 100%; overflow: hidden;" *ngIf="tablet$ | async">
  <swiper #swiper style="width: 100%;" [slidesPerView]="(mobile$ | async) ? 2 : 4" [spaceBetween]="10"
          scrollbar=".swiper-scrollbar">
    <ng-container *ngFor="let badge of badges">
      <ng-container *ngIf="!badge.hidden">
        <ng-template swiperSlide>
          <ng-container *ngIf="badge?.component else notComponent">
            <app-insight-badge-container [data]="data" [badgeComponent]="badge?.component"
                                         (anchorClick)="onAnchorClick($event)"></app-insight-badge-container>
          </ng-container>
          <ng-template #notComponent>
            <app-insight-badge [badge]="badge" (anchorClick)="onAnchorClick($event)"></app-insight-badge>
          </ng-template>
        </ng-template>
      </ng-container>
    </ng-container>
  </swiper>
  <div class="swiper-scrollbar js-swiper-scrollbar"></div>
</div>
